import React, {useState, useEffect}from 'react'
import PropTypes from 'prop-types'

// Atom
// import Button, { ButtonCategory } from 'Components/Atoms/Button'

import useWindowSize from '../../../../Hooks/useWindowSize';

function AnotherComparePlanCardMol(props) {
	const {
		setRegresaPlanes,
		refHead,
		refPrice,
		itemsHeadRef,
		itemsPriceRef,
	} = props

	const onClickAdd = () =>{
		setRegresaPlanes(true);
	}

	const {
		    width: widthWindos, 
		     // height: wheightWindos, 
		} = useWindowSize()

	const [heigthHead, setHeigthHead] = useState(0)
	const [heigthPrice, setHeigthPrice] = useState(0)

	const minHeightForHead = () => {
			// console.group("Head")
			// console.log("Elementos Head", itemsHeadRef)
			// console.log("Elementos Head current", itemsHeadRef.current)
			// console.log("widht", widthWindos)
			if(itemsHeadRef){
				setHeigthHead(0)
				// console.log("Elementos Head 2", itemsHeadRef)
				// console.log("Elementos Head 2 Current", itemsHeadRef.current)
				const valuesHeightHead = []
				// console.log(valuesHeightHead)
				// console.log(Object.keys(itemsHeadRef.current).forEach(function(key, index) {
				// 	console.log("key y index", key, index) 
				// }))
				Object.keys(itemsHeadRef.current).forEach(function(key, index) {
					// console.log("heigth Head" + index + " " + key, itemsHeadRef.current[key]?.clientHeight)
					// console.log("heigth Head off" + index + " " + key, itemsHeadRef.current[key]?.offsetHeight)
					valuesHeightHead[index] = itemsHeadRef.current[key]?.offsetHeight
				})
				
				// console.log("Values pure", valuesHeightHead)
				// console.log("heigth head", Math.max(valuesHeightHead.filter(element => element !== undefined)))
				
				setHeigthHead(Math.max(...valuesHeightHead.filter(element => element !== undefined)))
				// console.log(Math.max(...valuesHeightHead.filter(element => element !== undefined)))
			}
			// console.groupEnd()
		}
		
		const minHeightForPrice = () => {
			if(itemsPriceRef){
				setHeigthPrice(0)
				const valuesHeightPrice = []
				Object.keys(itemsPriceRef.current).forEach(function(key, index) {
					// console.log("heigth Price" + index + " " + key,itemsPriceRef.current[key]?.clientHeight)
					valuesHeightPrice[index] = itemsPriceRef.current[key]?.offsetHeight 
				})
				// console.log("heigth Price", Math.max(valuesHeightPrice.filter(element => element !== undefined)))
				setHeigthPrice( Math.max(...valuesHeightPrice.filter(element => element !== undefined)))
				// console.log(heigthPrice)
			}
		}
			 
		//Primera carga el bloque head 
		useEffect(()=>{
			if(widthWindos >= 960){
				minHeightForHead()
			}else{
				// Retraso para primera vez que se carga en movil
				const timer = setTimeout(() => {
					minHeightForHead()
				}, 1000);
				return () => clearTimeout(timer);
			}
			// eslint-disable-next-line react-hooks/exhaustive-deps
		},[])
		
		// Para resize
		useEffect(()=>{
			minHeightForHead()
			// eslint-disable-next-line react-hooks/exhaustive-deps
		},[itemsHeadRef, widthWindos])
		
		//Primera carga el bloque Price
		useEffect(()=>{
			if(widthWindos >= 960){
				minHeightForPrice()
			}else{
				// Retraso para primera vez que se carga en movil
				const timer = setTimeout(() => {
					minHeightForPrice()
				}, 1000);
				return () => clearTimeout(timer);
			}
			// eslint-disable-next-line react-hooks/exhaustive-deps
		},[])
		
		// Para resize
		useEffect(()=>{
			minHeightForPrice()
			// eslint-disable-next-line react-hooks/exhaustive-deps
		},[itemsPriceRef, widthWindos])
	
	return (
		<div className="cPlanV2Wrap compareWrap">
			<div className="cPlanV2 compare">
				<div className="cPlanV2Flag"></div>
				<div 
					className="cPlanV2Head" 
					ref={refHead}
					style={{minHeight: heigthHead + "px"}}
					// style={{minHeight: (heigthHead + 30) + "px"}}
				>
					<h3>Comparar otro plan</h3>
				</div>
				<div className="cPlanV2Prices" 
					ref={refPrice} 
					style={{minHeight: heigthPrice + "px"}}>
				</div>
				<div className="cPlanV2Actions">
					<a href="#!" className="btn btnTransGris withIco" onClick={onClickAdd}>
						<i className="ico-plus-circle"></i>
						Agregar Plan
					</a>
				</div>
			</div>
		</div>
	)
}

AnotherComparePlanCardMol.defaultProps = {
	onClickAdd: () => console.log('add')
}

AnotherComparePlanCardMol.propTypes = {
	onClickAdd: PropTypes.func,
}

export default AnotherComparePlanCardMol
